var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAqaaidActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 226.477,
    height: 216.018,
    viewBox: "0 0 226.477 216.018",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7959",
    "data-name": "Group 7959",
    transform: "translate(-44.166 -287.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39367",
    "data-name": "Path 39367",
    d: "M213.74,288.5,45.687,293.971l56.405,24.608,166.965-5.469Z",
    transform: "translate(0.081 0)",
    fill: "none",
    stroke: "#ffffff",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39368",
    "data-name": "Path 39368",
    d: "M45.666,458.674l.1-169.067,56.405,24.608V496.953Z",
    transform: "translate(0 4.364)",
    fill: "none",
    stroke: "#ffffff",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39369",
    "data-name": "Path 39369",
    d: "M223.866,472.622l.175-179.126L57.076,298.964V481.7Z",
    transform: "translate(45.098 19.734)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39370",
    "data-name": "Path 39370",
    d: "M45.687,298.864l56.405,29.654,166.919-9.183.046,15.421-166.965,8.389-56.405-30.4Z",
    transform: "translate(0.081 40.952)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39371",
    "data-name": "Path 39371",
    d: "M73.469,312.446v12.769l70.538-4.47v-12.2Z",
    transform: "translate(109.891 79.2)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39372",
    "data-name": "Path 39372",
    d: "M57.944,311.042,47.2,304.24v9.3l10.739,7.05Z",
    transform: "translate(6.082 62.203)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39373",
    "data-name": "Path 39373",
    d: "M62.711,313.872l-10.739-6.8v9.3l10.739,7.05Z",
    transform: "translate(24.922 73.389)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1664",
    "data-name": "Line 1664",
    y2: 9.448,
    transform: "translate(69.699 376.563)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39374",
    "data-name": "Path 39374",
    d: "M109.515,390.939l-49.3,3.805V311.292l49.3-2.011Z",
    transform: "translate(57.492 82.13)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1665",
    "data-name": "Line 1665",
    y2: 59.888,
    transform: "translate(142.355 404.415)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAqaaidActive);
export default __webpack_public_path__ + "static/media/Aqaaid_active.4f8f3867242cfec2ac55b4271286a1c7.svg";
export { ForwardRef as ReactComponent };